import Loading from './Loading';
import LoadingSingle from './Simple';
import LoadingSending from './Sending';

export { LoadingSingle, LoadingSending };
export default Loading;